const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const messagesFrom = (value: unknown): string[] => {
  const values = Array.isArray(value) ? value : isRecord(value) ? Object.values(value) : [];
  return values.flat().filter((message): message is string => typeof message === 'string' && !!message.trim());
};

export const getDocumentUploadFailure = (error: unknown, fallback: string) => {
  const response = isRecord(error) && isRecord(error.response) ? error.response : undefined;
  const body = response && isRecord(response.data) ? response.data : undefined;
  // Laravel validation uses errors; FileManagerController::sendError uses data.
  const details = [...messagesFrom(body?.errors), ...messagesFrom(body?.data)];
  const storageFull = response?.status === 413 && details.includes('remaining space is not enough');
  const message = response?.status === 422
    ? details[0] || (typeof body?.message === 'string' && body.message.trim()) || fallback
    : fallback;

  return { storageFull, message };
};

export type DocumentUploadErrorKind = 'storage' | 'size' | 'inspection' | 'validation' | 'permission' | 'general';

export const getDocumentUploadErrorKind = (error: unknown): DocumentUploadErrorKind => {
  const response = (error as { response?: { status?: number; data?: { data?: unknown } } } | null)?.response;
  const status = response?.status;
  const detail = response?.data?.data;

  if (status === 413) return Array.isArray(detail) && detail.includes('remaining space is not enough') ? 'storage' : 'size';
  if (status === 503 && (detail as { code?: string })?.code === 'UPLOAD_INSPECTION_UNAVAILABLE') return 'inspection';
  if (status === 422) return 'validation';
  if (status === 401 || status === 403) return 'permission';
  return 'general';
};
